<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Source reliable distributors across Africa</h2>
    <p>Asoko provides tailored research-as-a-service to support the world’s leading corporates in navigating Africa’s distribution and reseller landscape. Businesses operating across the continent save time and money using Asoko’s market mapping solutions to better understand their business environment. A tailor-built market map can help you shortlist and verify all the top companies in your target country, industry or sub-sector, enabling you to source legitimate trade partners to fit your growth plans across the continent.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More About Market Maps</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mncs-distribution-team-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'MNCs Distribution Team Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'MNCs Distribution Team Block',
      })
      this.$router.push('/about/solutions/market-map')
    },
  },
}
</script>
